import { DropdownDivider } from 'foundations-components/transitional/components/Dropdown';
import { ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
export const insertDividers = groups => {
  return groups.flatMap((group, index, array) => {
    const isLastGroup = index === array.length - 1;
    return isLastGroup ? [group] : [group, /*#__PURE__*/_jsx(DropdownDivider, {
      "data-test-id": "action-divider"
    }, `divider-${index}`)];
  });
};
export const filterAndFlattenActionGroups = actionGroups => {
  return actionGroups.map(actionGroup => actionGroup.filter(Boolean).map((action, index) => /*#__PURE__*/_jsx(ListItem, {
    children: action
  }, `action-${index}`))).filter(actionGroup => actionGroup.length > 0);
};